import Link from "next/link";

const MobileNavbar = ({ navLinks = [] }) => {
  return (
    <div className="row lg:hidden flex xs:pt-4 lg:min-h-max xs:min-h-[48px] min-h-[32px]">
      <div className="w-full pl-3">
        <ul className="flex gap-3 overflow-x-scroll w-full pb-[6px] custom-scroll">
          {navLinks.map((nav) => (
            <li
              key={nav.menuKey}
              className="px-2 py-1 bg-secondary-500 text-body-text-3-sb whitespace-nowrap rounded min-h-[28px]"
            >
              <Link href={nav.link} prefetch={false}>
                {nav.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MobileNavbar;
